module.exports = __webpack_public_path__ + "img/logo-web-pay-plus.e0714407.png";